import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
/// React router dom
import { Routes, Route, Outlet } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";

/// Dashboard
import Home from "./components/Dashboard/Home";
import DashboardDark from "./components/Dashboard/DashboardDark";
import Dashboard2 from "./components/Dashboard/Dashboard2";
import Dashboard3 from "./components/Dashboard/Dashboard3";
import Dashboard4 from "./components/Dashboard/Dashboard4";
import Crm from "./components/Dashboard/Crm";
import Analytics from "./components/Dashboard/Analytics";
import Products from "./components/Dashboard/Products";
import Sales from "./components/Dashboard/Sales";
import Blog from "./components/Dashboard/Blog";
import Projects from "./components/Dashboard/Projects";
import Task from "./components/Dashboard/Task";
import Encounters from "./components/Dashboard/Encounters";
import AmazingChartsPatients from "./components/Dashboard/AmazingChartsPatients";
import TebraPatients from "./components/Dashboard/TebraPatients";
import TebraEncounters from "./components/Dashboard/TebraEncounters";

//Apps
import User from "./components/AppsMenu/AppProfile/User";
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import AppProfile2 from "./components/AppsMenu/AppProfile/AppProfile2";
import EditProfile from "./components/AppsMenu/AppProfile/EditProfile";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";
import Calendar from "./components/AppsMenu/Calendar/Calendar";

/// Product List
import ProductGrid from "./components/AppsMenu/Shop/ProductGrid/ProductGrid";
import ProductList from "./components/AppsMenu/Shop/ProductList/ProductList";
import ProductDetail from "./components/AppsMenu/Shop/ProductGrid/ProductDetail";
import ProductOrder from "./components/AppsMenu/Shop/ProductOrder";
import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
import Customers from "./components/AppsMenu/Shop/Customers/Customers";

/// Charts
import SparklineChart from "./components/charts/Sparkline";
import ChartJs from "./components/charts/Chartjs";
import RechartJs from "./components/charts/rechart";
import ApexChart from "./components/charts/apexcharts";

/// Bootstrap
import UiAccordion from "./components/bootstrap/Accordion";
import UiAlert from "./components/bootstrap/Alert";
import UiBadge from "./components/bootstrap/Badge";
import UiButton from "./components/bootstrap/Button";
import UiModal from "./components/bootstrap/Modal";
import UiButtonGroup from "./components/bootstrap/ButtonGroup";
import UiListGroup from "./components/bootstrap/ListGroup";
import UiCards from "./components/bootstrap/Cards";
import UiCarousel from "./components/bootstrap/Carousel";
import UiDropDown from "./components/bootstrap/DropDown";
import UiPopOver from "./components/bootstrap/PopOver";
import UiProgressBar from "./components/bootstrap/ProgressBar";
import UiTab from "./components/bootstrap/Tab";
import UiPagination from "./components/bootstrap/Pagination";
import UiGrid from "./components/bootstrap/Grid";
import UiTypography from "./components/bootstrap/Typography";

/// Plugins
import Select2 from "./components/PluginsMenu/Select2/Select2";
import MainSweetAlert from "./components/PluginsMenu/SweetAlert/SweetAlert";
import Toastr from "./components/PluginsMenu/Toastr/Toastr";
import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";
// Widget
import Widget from "./pages/Widget";
/// Table
import SortingTable from "./components/table/SortingTable/SortingTable";
import FilteringTable from "./components/table/FilteringTable/FilteringTable";
import BootstrapTable from "./components/table/BootstrapTable";
/// Form
import Element from "./components/Forms/Element/Element";
import Wizard from "./components/Forms/Wizard/Wizard";
import CkEditor from "./components/Forms/CkEditor/CkEditor";
import Pickers from "./components/Forms/Pickers/Pickers";
import FormValidation from "./components/Forms/FormValidation/FormValidation";
/// Pages
import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";

import { ThemeContext } from "../context/ThemeContext";
import { navtoggle } from "../store/actions/AuthActions";

const allroutes = [
  // Dashboard
  { url: "", component: <Home /> },
  { url: "dashboard", component: <Home /> },
  { url: "dashboard-dark", component: <DashboardDark /> },
  { url: "index-3", component: <Dashboard2 /> },
  { url: "index-4", component: <Dashboard3 /> },
  { url: "index-5", component: <Dashboard4 /> },
  { url: "crm", component: <Crm /> },
  { url: "analytics", component: <Analytics /> },
  { url: "products", component: <Products /> },
  { url: "sales", component: <Sales /> },
  { url: "blog", component: <Blog /> },
  { url: "project", component: <Projects /> },
  { url: "task", component: <Task /> },
  { url: "encounters", component: <Encounters /> },
  { url: "amazing-charts-patients", component: <AmazingChartsPatients /> },
  { url: "tebra-patients", component: <TebraPatients /> },
  { url: "tebra-encounters", component: <TebraEncounters /> },

  //Apps

  { url: "user", component: <User /> },
  { url: "app-profile", component: <AppProfile /> },
  { url: "app-profile-2", component: <AppProfile2 /> },
  { url: "edit-profile", component: <EditProfile /> },
  { url: "post-details", component: <PostDetails /> },
  // Apps
  { url: "email-compose", component: <Compose /> },
  { url: "email-inbox", component: <Inbox /> },
  { url: "email-read", component: <Read /> },
  { url: "app-calender", component: <Calendar /> },

  // Shop
  { url: "ecom-product-grid", component: <ProductGrid /> },
  { url: "ecom-product-list", component: <ProductList /> },
  { url: "ecom-product-detail", component: <ProductDetail /> },
  { url: "ecom-product-order", component: <ProductOrder /> },
  { url: "ecom-checkout", component: <Checkout /> },
  { url: "ecom-invoice", component: <Invoice /> },
  { url: "ecom-customers", component: <Customers /> },
  // Chart
  { url: "chart-sparkline", component: <SparklineChart /> },
  { url: "chart-chartjs", component: <ChartJs /> },
  { url: "chart-apexchart", component: <ApexChart /> },
  { url: "chart-rechart", component: <RechartJs /> },
  // Bootstrap
  { url: "ui-accordion", component: <UiAccordion /> },
  { url: "ui-alert", component: <UiAlert /> },
  { url: "ui-badge", component: <UiBadge /> },
  { url: "ui-button", component: <UiButton /> },
  { url: "ui-modal", component: <UiModal /> },
  { url: "ui-button-group", component: <UiButtonGroup /> },
  { url: "ui-list-group", component: <UiListGroup /> },
  { url: "ui-card", component: <UiCards /> },
  { url: "ui-carousel", component: <UiCarousel /> },
  { url: "ui-dropdown", component: <UiDropDown /> },
  { url: "ui-popover", component: <UiPopOver /> },
  { url: "ui-progressbar", component: <UiProgressBar /> },
  { url: "ui-tab", component: <UiTab /> },
  { url: "ui-pagination", component: <UiPagination /> },
  { url: "ui-typography", component: <UiTypography /> },
  { url: "ui-grid", component: <UiGrid /> },
  // Plugin
  { url: "uc-select2", component: <Select2 /> },
  { url: "uc-sweetalert", component: <MainSweetAlert /> },
  { url: "uc-toastr", component: <Toastr /> },
  { url: "uc-lightgallery", component: <Lightgallery /> },
  // Widget
  { url: "widget-basic", component: <Widget /> },
  // Form
  { url: "form-element", component: <Element /> },
  { url: "form-wizard", component: <Wizard /> },
  { url: "form-ckeditor", component: <CkEditor /> },
  { url: "form-pickers", component: <Pickers /> },
  { url: "form-validation", component: <FormValidation /> },

  // table
  { url: "table-filtering", component: <FilteringTable /> },
  { url: "table-sorting", component: <SortingTable /> },
  { url: "table-bootstrap-basic", component: <BootstrapTable /> },
];

function NotFound() {
  const url = allroutes.map((route) => route.url);
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  if (url.indexOf(path) <= 0) {
    return <Error404 />;
  }
}

const Markup = () => {
  return (
    <>
      <Routes>
        <Route path="/page-lock-screen" element={<LockScreen />} />
        <Route path="/page-error-400" element={<Error400 />} />
        <Route path="/page-error-403" element={<Error403 />} />
        <Route path="/page-error-404" element={<Error404 />} />
        <Route path="/page-error-500" element={<Error500 />} />
        <Route path="/page-error-503" element={<Error503 />} />
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { menuToggle, sidebariconHover } = useContext(ThemeContext);

  const dispatch = useDispatch();
  const sideMenu = useSelector((state) => state.sideMenu);
  // const handleToogle = () => {
  //   dispatch(navtoggle());
  // };
  return (
    <div
      id="main-wrapper"
      className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${
        sideMenu ? "menu-toggle" : ""
      }`}
    >
      <Nav />
      <div
        className="content-body"
        style={{ minHeight: window.screen.height - 45 }}
      >
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

export default Markup;
